var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_45_101589)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 40,
    r: 40,
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 40,
    r: 39.5,
    stroke: "#FF6600"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4993 65.8333C40.9257 65.8333 37.5674 65.1552 34.4243 63.799C31.2813 62.4427 28.5473 60.6021 26.2223 58.2771C23.8973 55.9521 22.0566 53.2181 20.7004 50.075C19.3441 46.9319 18.666 43.5736 18.666 40C18.666 36.4264 19.3441 33.0681 20.7004 29.925C22.0566 26.7819 23.8973 24.0479 26.2223 21.7229C28.5473 19.3979 31.2813 17.5573 34.4243 16.201C37.5674 14.8448 40.9257 14.1667 44.4993 14.1667C48.073 14.1667 51.4313 14.8448 54.5743 16.201C57.7174 17.5573 60.4514 19.3979 62.7764 21.7229C65.1014 24.0479 66.9421 26.7819 68.2983 29.925C69.6546 33.0681 70.3327 36.4264 70.3327 40C70.3327 43.5736 69.6546 46.9319 68.2983 50.075C66.9421 53.2181 65.1014 55.9521 62.7764 58.2771C60.4514 60.6021 57.7174 62.4427 54.5743 63.799C51.4313 65.1552 48.073 65.8333 44.4993 65.8333ZM44.4993 61.9583C50.6294 61.9583 55.8216 59.8311 60.0761 55.5767C64.3305 51.3223 66.4577 46.13 66.4577 40C66.4577 37.3882 66.0056 34.873 65.1014 32.4547C64.1973 30.0363 62.9271 27.8368 61.291 25.8562L30.3556 56.7917C32.2931 58.4708 34.478 59.7517 36.9104 60.6344C39.3427 61.517 41.8724 61.9583 44.4993 61.9583ZM27.7723 54.1437L58.6431 23.2729C56.6625 21.5937 54.4631 20.3021 52.0447 19.3979C49.6263 18.4937 47.1112 18.0417 44.4993 18.0417C38.3693 18.0417 33.1771 20.1689 28.9226 24.4233C24.6682 28.6777 22.541 33.87 22.541 40C22.541 42.6269 23.0146 45.1566 23.9618 47.5889C24.9091 50.0213 26.1792 52.2062 27.7723 54.1437Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_45_101589",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_45_101589"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_45_101589",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.9cc261fb9cc597ab3406cfb59a41b09f.svg";
export { ForwardRef as ReactComponent };